import { SET_TOGGLE_BTN } from "../constant/actionTypes";

export const setToggle = (value) => {
    return{
        type:SET_TOGGLE_BTN,
        data:value
    }
}